module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921001149_T.a10da6d9.jpg";